const api_url = "https://clairity-api-vzi7qgnc5q-uc.a.run.app/clairity";

export default api_url;